'use strict';

var debounce = require('lodash/debounce');
var timeout;

module.exports = {
    widgets: function () {
        const targets = 'yotpo-widget-instance';
        clearTimeout(timeout);
        // Wait until synchronous thread end
        window.refreshYotpoWidgets = debounce(() => {
            var $completeWidgets = $('.' + targets + '[data-yotpo-element-loaded=true]').toggleClass(targets, false);
            window.yotpo?.refreshWidgets?.();
            window.yotpoWidgetsContainer?.initWidgets?.();

            timeout = setTimeout(() => $completeWidgets.toggleClass(targets, true), 100);
        }, 1000);
    }
}
